import { IGroupModel } from "models/dto/ZoomiLxp/Models/GroupModels/IGroupModel";
import { IFileModel } from "models/dto/ZoomiLxp/Models/Common/IFileModel";
import { IOptionsItem } from "./select.helper";
import { IGroupAssignment } from "models/dto/ZoomiLxp/Models/Profile/IGroupAssignment";
import { GroupAssignmentTypes } from "models/dto/ZoomiLxp/Utilities/Enumerations/GroupAssignmentTypes";
import { GroupThresholdMode } from "models/dto/ZoomiLxp/Utilities/Enumerations/GroupThresholdMode";

export type GroupAssignmentType = IGroupAssignment & { groupName: string };

export const optionToGroupModelConverter = (optionsItem: IOptionsItem): IGroupModel => {
	const grp: IGroupModel = {
		id: Number(optionsItem.value),
		name: optionsItem.label,
		displayName: optionsItem.label,
		description: "",
		thumbnail: {} as IFileModel,
		autoAssignCourses: false,
		discoverableForLearners: false,
		enableExamThreshold: false,
		examThresholdMode: GroupThresholdMode.PerCourse,
		enableZ1Threshold: false,
		z1ThresholdMode: GroupThresholdMode.PerCourse,
		enableEngagementThreshold: false,
		engagementThresholdMode: GroupThresholdMode.PerCourse,
		enableProgressThreshold: false,
		enableCertification: false,
		courses: [],
	};
	return grp;
};

export const getChangedGroup = (optionItem: IOptionsItem, type: GroupAssignmentTypes) => {
	return optionToGroupAssignModelConverter(optionItem, type);
};

export const optionToGroupAssignModelConverter = (
	optionsItem: IOptionsItem,
	changeType: GroupAssignmentTypes
): GroupAssignmentType => {
	const grp: GroupAssignmentType = {
		groupName: optionsItem.label,
		groupId: Number(optionsItem.value),
		type: changeType,
	};
	return grp;
};
